import React, { FC } from 'react';

interface SectionProps {
  id: string;
  title: string;
  /** One-line context shown under the title. */
  intro?: string;
  /** Plain-English definition from the API, behind a disclosure. */
  definition?: string;
  className?: string;
  children: React.ReactNode;
}

export const Section: FC<SectionProps> = ({
  id,
  title,
  intro,
  definition,
  className,
  children,
}) => (
  <section
    id={`ops-${id}`}
    className={`ops-section ${className ?? ''}`}
    aria-labelledby={`ops-${id}-title`}
  >
    <header className='ops-section-header'>
      <h3 id={`ops-${id}-title`}>{title}</h3>
      {intro && <p className='ops-section-intro'>{intro}</p>}
    </header>
    {children}
    {definition && (
      <details className='ops-details'>
        <summary>How it&apos;s measured</summary>
        <p>{definition}</p>
      </details>
    )}
  </section>
);

export const Empty: FC<{ children?: React.ReactNode }> = ({ children }) => (
  <p className='ops-empty'>{children ?? 'No data in this range.'}</p>
);

interface SimpleTableProps {
  columns: Array<{ key: string; label: string; align?: 'left' | 'right' }>;
  rows: Array<Record<string, React.ReactNode>>;
  rowKey: (row: Record<string, React.ReactNode>, i: number) => string;
  caption?: string;
}

export const SimpleTable: FC<SimpleTableProps> = ({
  columns,
  rows,
  rowKey,
  caption,
}) => (
  <div className='ops-table-scroll'>
    <table className='ops-table'>
      {caption && <caption>{caption}</caption>}
      <thead>
        <tr>
          {columns.map((c) => (
            <th key={c.key} className={c.align === 'right' ? 'num' : undefined}>
              {c.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={rowKey(r, i)}>
            {columns.map((c) => (
              <td
                key={c.key}
                className={c.align === 'right' ? 'num' : undefined}
              >
                {r[c.key]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
